import React, { useCallback, useContext, useEffect, useState } from "react";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { NewInterview } from "../classes/new_interview_class";
import { EducationFormContext } from "../hooks/EducationFormContext";
import { NewInterviewShape } from "../interfaces/classTypes";

export const ParentInterviewSelector: React.FunctionComponent = () => {
  const { t, uuid, profileInterviews } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(EducationFormContext);
  const [fullInterviewList, setFullInterviewList] = useState<
    NewInterviewShape[]
  >();

  useEffect(() => {
    let loadedInterviews = profileInterviews.map((id) =>
      NewInterview.find_by_id(id)
    );
    setFullInterviewList(loadedInterviews);
    setGoalState((prevState) => {
      return {
        ...prevState,
        selectedInterview: null,
      };
    });
  }, [profileInterviews]);

  const dropdownList = () => {
    if (!fullInterviewList) return;
    return fullInterviewList.map((interview) => {
      return (
        <option key={uuid()} value={interview.id} id={interview.id.toString()}>
          {interview.name}
        </option>
      );
    });
  };
  const handleSelect = useCallback(
    (event) => {
      event.nativeEvent.stopImmediatePropagation();
      event.preventDefault();
      event.persist();

      var selection = fullInterviewList.find(
        (interview) => interview.id == event.target.value
      );
      if (selection != null)
        setGoalState((prevState) => {
          return {
            ...prevState,
            selectedInterview: selection,
          };
        });
    },
    [fullInterviewList]
  );

  useEffect(() => {
    var newSelector = document.getElementById(
      "goal-link-parent-interview-dropdown"
    );
    newSelector.addEventListener("keydown", (event) => {
      if (
        goalState.selectedInterview &&
        $(newSelector).val() == goalState.selectedInterview.id &&
        event.key == "Enter"
      ) {
        event.preventDefault();
      }
    });
  }, [goalState.selectedInterview]);

  return (
    <>
      <div className="goal-boxed-input-area">
        <div className="goal-form-input-row">
          <label
            htmlFor="goal-link-parent-interview-dropdown"
            className="goal-input-area-title"
          >
            {t("views.goals.headings.interview")}
          </label>
          <select
            name=""
            value={
              goalState.selectedInterview == null
                ? ""
                : goalState.selectedInterview.id
            }
            id="goal-link-parent-interview-dropdown"
            className="goal-minimal-dropdown dropdown-feature-length"
            onChange={(e) => {
              e.preventDefault();
              e.persist();
              e.stopPropagation();
              handleSelect(e);
            }}
          >
            <option value="" disabled>
              {t("views.goals.headings.select")}
            </option>{" "}
            {dropdownList()}
          </select>
        </div>
      </div>
    </>
  );
};
